import * as React from 'react';
import { DropdownItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { selectionTypeConfiguration } from './selection-types/configuration-selection-type';
import { GroupByPanelTexts } from './group-by-panel-texts';
import { ElementLoader } from 'ui/common/element-loader/element-loader';
import { fieldsMap } from '../fields-map';
import { ExpandableBox } from 'app/area/reports/components/expandable-box';
import { SelectionFieldItem, SelectionTypeItem, SelectionType, SelectionValue } from '../types-fields';
import { SelectItem } from 'app/area/reports/types';
import { GroupBySort } from './group-by-sort';

interface SelectionsFieldComponentProps {
  item: SelectionFieldItem;
  selectedGroupByFields?: SelectionFieldItem[];

  sortOrderTypes: SelectItem[];

  onModifyGroupBySelections: (fields: SelectionFieldItem[]) => void;
  onChangeSelectionField: (modifiedItem: SelectionFieldItem) => void;

  translation: GroupByPanelTexts;
}

class SelectionsFieldComponent extends React.PureComponent<SelectionsFieldComponentProps, {}> {

  private handleOnLoadMenuItems = (
    item: SelectionFieldItem
  ): DropdownItem[] => {
    const { onModifyGroupBySelections } = this.props;

    const handleOnRemove = () => {
      const modifiedLGroupByFields = [...this.props.selectedGroupByFields];
      const indexOfModifiedItem = this.props.selectedGroupByFields.findIndex(
        i => i.selectionNo === item.selectionNo
      );
      modifiedLGroupByFields.splice(indexOfModifiedItem, 1);
      onModifyGroupBySelections(modifiedLGroupByFields);
    };

    const handleOnMoveUp = () => {
      onModifyGroupBySelections(
        fieldsMap.moveFieldUp(this.props.selectedGroupByFields, item)
      );
    };

    const handleOnMoveDown = () => {
      onModifyGroupBySelections(
        fieldsMap.moveFieldDown(this.props.selectedGroupByFields, item)
      );
    };

    const showMissingValues = () => {

      onModifyGroupBySelections(
        fieldsMap.showMissingValues(this.props.selectedGroupByFields, item)
      );
    };

    const menuItems = [
      {
        value: '1',
        description: this.props.translation.group_by_remove,
        onClick: handleOnRemove
      }
    ];
    if (fieldsMap.canMoveUp(this.props.selectedGroupByFields, item)) {
      menuItems.push({
        value: '2',
        description: this.props.translation.group_by_move_up,
        onClick: handleOnMoveUp
      });
    }
    if (fieldsMap.canMoveDown(this.props.selectedGroupByFields, item)) {
      menuItems.push({
        value: '3',
        description: this.props.translation.group_by_move_down,
        onClick: handleOnMoveDown
      });
    }
    if (!!item.field && !!item.field.showMissingValues) {
      menuItems.push({
        value: '4',
        description: !!item.value.fillEmpty
          ? this.props.translation.group_by_hide_missing_values : this.props.translation.group_by_show_missing_values,
        onClick: showMissingValues
      });
    }

    return menuItems;
  };

  private onChangeSelectionType = (selection: SelectionValue) => {
    const selectionField = this.props.item;
    this.props.onChangeSelectionField({
      ...selectionField,
      value: selection
    });
  };

  private renderSelection = (selection: SelectionTypeItem) => {
    const SelectionTypeComponent = selectionTypeConfiguration[selection.type];
    const selected = !!this.props.item.value && selection.type === this.props.item.value.type;

    return <SelectionTypeComponent
      key={selection.type}
      selectionField={this.props.item}
      selectionItem={selection}
      onChange={this.onChangeSelectionType}
      checked={selected}
      isFirstSelection={this.props.selectedGroupByFields.indexOf(this.props.item) === 0}
      translation={this.props.translation}
    />;
  };

  public render(): JSX.Element {
    const {
      item, sortOrderTypes, translation
    } = this.props;

    const menuItems = this.handleOnLoadMenuItems(item);
    const hide = !item.selectionTypes || (item.selectionTypes.length === 1 && item.selectionTypes[0].type === SelectionType.ActualValue);

    const description = item.field.allLevelDescription || item.field.description;

    return <ExpandableBox key={item.field.value}
      title={description}
      menuItems={menuItems}
      contentMessage={!!item.value && !!item.value.fillEmpty && <p>{this.props.translation.group_by_missing_values_are_included}</p>}
    >
      {!item.selectionTypes ? <ElementLoader />
        : !hide && item.selectionTypes.map(selection => this.renderSelection(selection))}
      <GroupBySort
        item={item}
        isSingleElement={hide}
        sortOrderTypes={sortOrderTypes}
        onChange={this.onChangeSelectionType}
        translation={translation}
      />
    </ExpandableBox>;
  }
}

export const SelectionsField = SelectionsFieldComponent;
